"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUserPicker = exports.serializeUserPicker = void 0;
const serializeUserPicker = (item) => {
    // TODO: Note `displayName` is not present in persisted item data...
    return (item.data.userEntries || [])
        ?.map((userEntry) => userEntry.displayName)
        .join(", ");
};
exports.serializeUserPicker = serializeUserPicker;
const validateUserPicker = (item) => {
    if (!item.required || item.data.userEntries?.length > 0) {
        return { valid: true };
    }
    return {
        valid: false,
        error: { message: "Please pick at least one user" },
    };
};
exports.validateUserPicker = validateUserPicker;
//# sourceMappingURL=userPicker.js.map